import '@babel/polyfill'

import Vue from 'vue'
import PrismicVue from 'prismic-vue'
import store from '../store'
import { linkResolver, parsePageData } from '../util'
import { KEY_NAMES } from '../constants.js'
import mountArgent from './util/mountArgent'
import smoothscroll from 'smoothscroll-polyfill'
import SiteHeader from '../components/organisms/SiteHeader.vue'
import CartDrawer from '../components/organisms/CartDrawer.vue'
import RegionDropdown from '../components/atoms/RegionDropdown.vue'
import { storeRegionRedirect } from './storeRegionRedirect'
import * as Sentry from '@sentry/browser'

import 'normalize.css/normalize.css'
import '../scss/index.scss'

// Report errors to Sentry
if (REPORT_ERRORS) {
  Sentry.init({
    dsn: 'https://961c67987fc1439d9803c0b4255a62a0@sentry.io/1414072',
    environment: NODE_ENV,
    release: Shopify.theme.name,
    integrations: [
      new Sentry.Integrations.Vue({
        Vue,
        attachProps: true,
      }),
    ],
  })
  Sentry.configureScope(scope => {
    scope.setUser({ id: parsePageData('customer.id') })
  })
}

const PRISMIC_ENDPOINT = 'https://iamgia.prismic.io/api/v2'

// Initialise Prismic
Vue.use(PrismicVue, {
  endpoint: PRISMIC_ENDPOINT,
  linkResolver,
})

window.prismic = {
  endpoint: PRISMIC_ENDPOINT,
}

window.REGION = REGION

/*
  - The Scroll Behavior specification has been introduced as an extension of the Window interface to allow for the developer to opt in to native smooth scrolling.
  - To date this has only been implemented in Firefox and chrome
  - Hence the polyfill
  - Ref: https://www.npmjs.com/package/smoothscroll-polyfill
*/
// kick off the polyfill!
smoothscroll.polyfill()

const argent = mountArgent()

// Set customer ID
store.commit('setCustomerId', {
  id: parsePageData('customer.id'),
})

// Initiate cart and wishlist data
store.dispatch('getCart')
store.dispatch('loadWishlist')

argent.then(argent => {
  /* Redirect customers to region store */
  storeRegionRedirect()

  new Vue({
    el: '#site-header',
    store,
    components: {
      SiteHeader,
    },
    mounted: () => {
      argent.registerCurrencySelector(`select[name="currency"]`)

      if (argent.baseCurrency !== argent.getCurrency()) {
        let currencyMessage = document.querySelector('.currency-message')

        if (currencyMessage) {
          currencyMessage.classList.add('show')
        }
      }
    },
  })

  new Vue({
    el: '#cart-drawer-holder',
    store,
    components: {
      CartDrawer,
    },
  })

  new Vue({
    el: '#footer',
    components: {
      RegionDropdown,
    },
  })
})

/* On clicking the 'ESC' key we switch off the cart drawer */
document.onkeydown = evt => {
  evt = evt || window.event
  if (evt.keyCode == 27) {
    store.commit('showCart', true)
    store.commit('showSearch', true)
  }
}

/*
  - Smooth Scroll functionality START
  - To effectively move the code, don't forget to import and init smoothscroll (see top)
*/
const smoothScroller = e => {
  e.preventDefault()

  let x = scrollButton.getAttribute('data-scroll-x')
  let y = scrollButton.getAttribute('data-scroll-y')

  window.scroll({
    top: x,
    left: y,
    behavior: 'smooth',
  })
}

let scrollButton = document.getElementById('backToTop')

if (scrollButton) {
  scrollButton.addEventListener('click', smoothScroller)

  let posY = window.pageYOffset || document.documentElement.scrollTop

  if (posY <= 0) {
    scrollButton.style.display = 'none'
  }
}

document.onscroll = () => {
  let posY = window.pageYOffset || document.documentElement.scrollTop

  if (posY > 0) {
    scrollButton.style.display = 'block'
  } else {
    scrollButton.style.display = 'none'
  }
}
/* Smooth Scroll functionality ENDS */

argent.then(argent => {
  const AFTERPAY_REGIONS = ['au', 'us']
  const templateName = parsePageData('template.name')
  const templateSuffix = parsePageData('template.suffix')
  const visitorCountryCode = localStorage.getItem(KEY_NAMES.visitorCountry)

  if ('index' === templateName) {
    import(/* webpackChunkName: "home-container" */ './home').then(m => m.default(Vue, store))
  }

  if ('collection' === templateName) {
    import(/* webpackChunkName: "collection-container" */ './collection').then(m =>
      m.default(Vue, store)
    )
  }

  if ('product' === templateName) {
    store.dispatch('fetchRecommendedProducts')

    // Show afterpay message for AUD only
    if (AFTERPAY_REGIONS.includes(visitorCountryCode)) {
      let afterpay = document.getElementById('afterpayInfo')
      if (afterpay) {
        afterpay.style.display = 'block'
      }
    }

    import(/* webpackChunkName: "product-container" */ './product').then(m => m.default(Vue, store))
  }

  if ('cart' === templateName) {
    // Show afterpay message for AUD only
    if (AFTERPAY_REGIONS.includes(visitorCountryCode)) {
      let afterpay = document.getElementById('afterpayInfo')
      if (afterpay) {
        afterpay.style.display = 'block'
      }
    }
  }

  if ('search' === templateName) {
    import(/* webpackChunkName: "search-container" */ './search').then(m => m.default(Vue, store))
  }

  if ('page' === templateName && 'wishlist' === templateSuffix) {
    import(/* webpackChunkName: "wishlist-container" */ './wishlist').then(m =>
      m.default(Vue, store)
    )
  }
})
